/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Select_Next_EventInputs */

const en_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the next event in the list`)
};

const fr_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner l'evenement suivant dans la liste`)
};

const de_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie das nächste Ereignis in der Liste aus.`)
};

const it_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona l'evento successivo nell'elenco`)
};

const ru_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите следующее событие в списке.`)
};

const es_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el próximo evento en la lista`)
};

const zh_cn2_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择列表中的下一个事件`)
};

const ja_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リスト内の次のイベントを選択してください`)
};

const hi_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूची में अगला इवेंट चुनें`)
};

const pt_pt2_shortcut_keys_desc_select_next_event = /** @type {(inputs: Shortcut_Keys_Desc_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o próximo evento da lista.`)
};

/**
* | output |
* | --- |
* | "Select the next event in the list" |
*
* @param {Shortcut_Keys_Desc_Select_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_select_next_event = /** @type {((inputs?: Shortcut_Keys_Desc_Select_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Select_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_select_next_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_select_next_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_select_next_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_select_next_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_select_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_select_next_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_select_next_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_select_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_select_next_event(inputs)
	return en_shortcut_keys_desc_select_next_event(inputs)
});